// import { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCircleCheck,
//   fas,
//   faChartBar,
// } from "@fortawesome/free-solid-svg-icons";
// const MarketCards = ({ report }) => {
//   const location = useLocation();
//   const pathName = location.pathname.split("/").filter(Boolean);
//   const navigate = useNavigate();
//   const [hoveredRegion, setHoveredRegion] = useState(null);
//   const [hoveredCountry, setHoveredCountry] = useState(null);
//   // Grouping countries by region
//   const groupedRegions = report?.regions?.reduce((acc, region) => {
//     if (!acc[region.region]) {
//       acc[region.region] = [];
//     }
//     acc[region.region].push(region.country);
//     return acc;
//   }, {});
//   const [userData, setUserData] = useState();
//   console.log(userData, "setUserData");
//   useEffect(() => {
//     const userDataFromSession = sessionStorage.getItem("user");
//     if (userDataFromSession) {
//       setUserData(JSON.parse(userDataFromSession));
//     }
//   }, []);
//   return (
//     <>
//       <div className="flex justify-content-end ">
//         <div className="bg-white rounded shadow p-6">
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">
//             Regional Markets
//           </h2>
//           {pathName[0] !== "report" && (
//             <div
//               className={`flex items-center text-gray-800 font-bold text-lg p-2 mb-4 rounded-lg transition duration-300 ${"bg-gray-300"}`}
//               style={{ cursor: "pointer" }}
//               onClick={() => navigate(`/report`, { state: report })}
//             >
//               Global Markets
//             </div>
//           )}
//           <div
//             style={{
//               maxHeight: "340px",
//               overflow: "auto",
//               scrollbarWidth: "none",
//               msOverflowStyle: "none",
//             }}
//           >
//             <ul className="list-none space-y-4">
//               {Object.keys(groupedRegions).map((regionName, index) => (
//                 <li key={index} className="">
//                   {/* Region Name */}
//                   <div
//                     className={`flex items-center text-gray-800 font-bold text-lg p-2 rounded-lg transition duration-300 ${
//                       hoveredRegion === regionName
//                         ? "bg-gray-400 "
//                         : "bg-gray-300"
//                     }`}
//                     style={{ cursor: "pointer" }}
//                     onMouseOver={() => setHoveredRegion(regionName)}
//                     onMouseOut={() => setHoveredRegion(null)}
//                     onClick={() =>
//                       navigate(`/report1?region=${regionName}`, {
//                         state: report,
//                         region: regionName,
//                       })
//                     }
//                   >
//                     {regionName}
//                   </div>

//                   {/* Countries under the Region */}
//                   <ul className="ml-6 mt-2 space-y-1">
//                     {groupedRegions[regionName]?.map((country, i) => (
//                       <li
//                         key={i}
//                         className={`text-gray-600 pl-2 p-1 rounded-lg transition duration-300 ${
//                           hoveredCountry === country ? "bg-gray-300" : ""
//                         }`}
//                         style={{ cursor: "pointer" }}
//                         onMouseOver={() => setHoveredCountry(country)}
//                         onMouseOut={() => setHoveredCountry(null)}
//                         onClick={() =>
//                           navigate(`/report1?country_name=${country}`, {
//                             state: report,
//                             country_name: country,
//                           })
//                         }
//                       >
//                         <FontAwesomeIcon icon={faChartBar} className="mr-2" />
//                         {country}
//                       </li>
//                     ))}
//                   </ul>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default MarketCards;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";

const MarketCards = ({ report }) => {
  const location = useLocation();
  const pathName = location.pathname.split("/").filter(Boolean);
  const navigate = useNavigate();
  const [hoveredRegion, setHoveredRegion] = useState(null);
  const [hoveredCountry, setHoveredCountry] = useState(null);

  // Grouping countries by region
  const groupedRegions = report?.regions?.reduce((acc, region) => {
    if (!acc[region.region]) {
      acc[region.region] = [];
    }
    acc[region.region].push(region.country);
    return acc;
  }, {});

  const [userData, setUserData] = useState();

  useEffect(() => {
    const userDataFromSession = sessionStorage.getItem("plans");
    if (userDataFromSession) {
      setUserData(JSON.parse(userDataFromSession));
    }
  }, []);
  console.log(userData, "userData ");
  // Function to handle navigation
  const handleNavigation = (path, state) => {
    console.log(path, state, "path");
    if (userData) {
      if (userData?.features?.RegionAndCountriesMarketStatistics === true) {
        navigate(path, state);
      } else {
        alert("Please upgrade your plan to access this content.");
        navigate("/pricing");
      }
    } else {
      alert("Please subscribe to a plan to access this content.");
      navigate("/pricing");
    }
  };

  return (
    <>
      <div className="flex justify-content-end ">
        <div className="bg-white rounded shadow p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Regional Markets
          </h2>
          {pathName[0] !== "report" && (
            <div
              className="flex items-center text-gray-800 font-bold text-lg p-2 mb-4 rounded-lg transition duration-300 bg-gray-300"
              style={{ cursor: "pointer" }}
              onClick={() => handleNavigation(`/report`, { state: report })}
            >
              Global Markets
            </div>
          )}
          <div
            style={{
              maxHeight: "340px",
              overflow: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <ul className="list-none space-y-4">
              {Object.keys(groupedRegions).map((regionName, index) => (
                <li key={index}>
                  {/* Region Name */}
                  <div
                    className={`flex items-center text-gray-800 font-bold text-lg p-2 rounded-lg transition duration-300 ${
                      hoveredRegion === regionName
                        ? "bg-gray-400"
                        : "bg-gray-300"
                    }`}
                    style={{ cursor: "pointer" }}
                    onMouseOver={() => setHoveredRegion(regionName)}
                    onMouseOut={() => setHoveredRegion(null)}
                    onClick={() =>
                      handleNavigation(`/report1?region=${regionName}`, {
                        state: report,
                        region: regionName,
                      })
                    }
                  >
                    {regionName}
                  </div>

                  {/* Countries under the Region */}
                  <ul className="ml-6 mt-2 space-y-1">
                    {groupedRegions[regionName]?.map((country, i) => (
                      <li
                        key={i}
                        className={`text-gray-600 pl-2 p-1 rounded-lg transition duration-300 ${
                          hoveredCountry === country ? "bg-gray-300" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onMouseOver={() => setHoveredCountry(country)}
                        onMouseOut={() => setHoveredCountry(null)}
                        onClick={() =>
                          handleNavigation(`/report1?country_name=${country}`, {
                            state: report,
                            country_name: country,
                          })
                        }
                      >
                        <FontAwesomeIcon icon={faChartBar} className="mr-2" />
                        {country}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketCards;
